import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./Header.scss";
import LanguageSelector from "./LanguageSelector";

const Header = () => {
  const { t } = useTranslation();
  return (
    <Navbar collapseOnSelect expand="lg" className="nav-container" bg="white">
      <Navbar.Brand href="https://app.forexhero.ai" className="ml-sm-5 ml-0" aria-label="Site link">
        <img
          alt=""
          src="/images/ch2.png"
          height="45"
          width={100}
          className="d-inline-block align-top"
        />
      </Navbar.Brand>
      {/* <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto">
          <Nav.Link href="https://forexhero.ai">{t("home")}</Nav.Link>
          <Nav.Link href="https://forexhero.ai/features">{t("features")}</Nav.Link>
          <Nav.Link href="https://forexhero.ai/pricing">{t("pricing")}</Nav.Link>
          <Nav.Link href="https://blog.forexhero.ai">{t("blog")}</Nav.Link>
          <Nav.Link href="https://docs.forexhero.ai/">
            {t("userguide")}
          </Nav.Link>
         <LanguageSelector></LanguageSelector>
        </Nav>
      </Navbar.Collapse> */}
    </Navbar>
  );
};

export default Header;
